<sc-flex vertical stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="erp.ui.articletype-calculationrule-editor.title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-padding>
    <form [formGroup]="formGroup" class="no-field-space">
      <sc-flex vertical stretchContent>
        <sc-dictionary-field class="input-title" [model]="calculationRuleAttribute?.name" [maxlength]="255"
          [required]="true" [defaultLabel]="'name'" labelDictionaryKey="erp.entity.calculationrule.name"
          (dictionaryChanged)="onNameChanged($event)">
        </sc-dictionary-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.calculationrule.precission"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="precission" required="true">
            @for (value of precissions; track value) {
              <mat-option [value]="value">
                {{ value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.calculationrule.attribute"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="attributeSelection">
            @for (value of getAttributesForSelection(); track value) {
              <mat-option [value]="value.id">
                <app-dictionary-entry-label [model]="value.name"></app-dictionary-entry-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.calculationrule.method"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="method" required="true">
            @for (value of methods; track value) {
              <mat-option [value]="value">
                {{ value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.calculationrule.sort-order"></sc-dictionary-label>
          </mat-label>
          <input matInput formControlName="sortValue">
        </mat-form-field>
      </sc-flex>
    </form>
  </sc-padding>

  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <button mat-stroked-button (click)="onClose()">
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-calculationrule-editor.action.cancel"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-calculationrule-editor.action.confirm"></sc-dictionary-label>
    </button>
  </sc-actionbar>
</sc-flex>
